// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/input-number/style/index.less
// module id = 1113
// module chunks = 1